<!-- src\App.vue -->
<script setup>
import { onMounted, ref } from 'vue'
import AppHeader from '@/components/layout/AppHeader.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import CookieBanner from '@/components/ui/CookieBanner.vue'
import PopupManager from '@/components/popup/PopupManager.vue'
import { setPopupRef } from '@/components/popup/usePopup'
import { useRoute } from 'vue-router'
import { initYandexMetrika } from '@/utils/metrika'

const route = useRoute()

const popupRef = ref(null)

onMounted(() => {
	if (popupRef.value) {
		setPopupRef(popupRef.value)
	}
})
</script>

<template>
	<div class="wrapper">
		<!-- <div :class="['wrapper', { 'no-overflow': route.name === 'Cases' }]"> -->
		<AppHeader />
		<main class="page">
			<RouterView />
		</main>
		<AppFooter />
	</div>

	<CookieBanner />
	<PopupManager ref="popupRef" />
</template>
